import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { FlowManagerService } from '../shared/services/flowmanager.service';

@Injectable()
export class MpQuestionnaireCanActivate implements CanActivate {
  constructor(router: Router, flowManager: FlowManagerService) {
    this.router = router;
    this.flowManager = flowManager;
  }

  canActivate() {
    if (this.flowManager.getAppType() !== 'tka' || this.flowManager.completedQuestionnaire) {
      return this.router.navigate(['/'], { queryParamsHandling: 'preserve' });
    }
    return true;
  }
}
